import type { ReactNode } from "react";
import { CheckCircle2, CircleDashed, XCircle } from "lucide-react";
import type { Source } from "../../../../api/twilio";
import { Field, TextInput } from "../../../../components/ui";

export function Card({ title, icon, testId, children, aside }: { title: string; icon: ReactNode; testId: string; children: ReactNode; aside?: ReactNode }) {
  return (
    <section className="glass rounded-[20px] p-6" data-testid={testId}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h2 className="flex items-center gap-2 text-lg font-medium text-white">{icon}{title}</h2>
        {aside}
      </div>
      <div className="mt-4">{children}</div>
    </section>
  );
}

export function CodeField({ value, onChange, id }: { value: string; onChange: (v: string) => void; id: string }) {
  return (
    <Field label="Fresh authenticator code (or a backup code)" htmlFor={id}>
      <TextInput id={id} value={value} onChange={(e) => onChange(e.target.value.trim())} autoComplete="one-time-code" inputMode="numeric" placeholder="6-digit code" data-testid={id} />
    </Field>
  );
}

export function SourceTag({ source, testId }: { source: Source; testId: string }) {
  if (!source) return null;
  return (
    <span data-testid={testId} className={`rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${source === "env" ? "bg-amber-400/15 text-amber-200" : "bg-emerald-400/15 text-emerald-200"}`}>
      {source === "env" ? "From Secrets" : "Saved on this page"}
    </span>
  );
}

export function CheckIcon({ ok, required }: { ok: boolean; required: boolean }) {
  if (ok) return <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-label="Passed" />;
  if (!required) return <CircleDashed className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" aria-label="Needs attention" />;
  return <XCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-label="Failed" />;
}

export const when = (iso: string) => new Date(iso).toLocaleString();
